@use "../../../styles/breakpoint.module.scss" as *;

.modal {
    position: fixed;
    inset: 0;
    z-index: 102;
}

.dialog {
    composes: gridContainer from "../../../styles/composable/layout.module.css";
    align-items: center;
    height: 100%;
    outline: 0;
}

.overlay {
    position: absolute;
    inset: 0;
    background-color: var(--overlay-black-56);
    z-index: 0;
}

.content {
    position: relative;
    grid-column: 2 / span 10;
    display: grid;
    grid-template-columns: subgrid;
    max-height: 94dvh;
    padding-block: var(--spacer-64);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    text-align: center;
    z-index: 1;

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}

.close {
    position: absolute;
    top: var(--spacer-16);
    right: var(--spacer-16);
    width: var(--spacer-24);
    height: var(--spacer-24);
}

.title {
    grid-column: 2 / span 8;
    font: var(--font-h-32);
    margin-bottom: var(--spacer-40);
    text-align: center;

    strong {
        font-weight: inherit;
        color: var(--red);
    }

    @media ($below-tablet) {
        grid-column: 1 / -1;
        padding: var(--spacer-32);
    }
}

.body {
    grid-column: 1 / -1;
    margin-inline: var(--spacer-32);
    font: var(--font-p-14);
}

.subheading {
    display: inline-block;
    margin-bottom: var(--spacer-24);
    padding: var(--spacer-8) var(--spacer-24);
    background-color: var(--eggplant);
    border-radius: var(--border-radius-full);
    color: var(--white);
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-align: center;
    text-transform: uppercase;

    strong {
        padding-right: var(--spacer-8);
        color: var(--beige);
    }
}

.qualifiers {
    display: flex;
    align-items: stretch;
    margin-bottom: var(--spacer-40);

    @media ($below-tablet) {
        position: relative;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1px;
        background-color: var(--pecan);
    }
}

.qualifier {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;

    @media ($below-tablet) {
        background-color: var(--off-white);
        padding: var(--spacer-24);

        &:nth-of-type(odd) {
            padding-left: 0;
        }

        &:nth-of-type(even) {
            padding-right: 0;
        }

        &:nth-of-type(-n + 2) {
            padding-top: 0;
        }

        &:nth-of-type(n + 3) {
            padding-bottom: 0;
        }
    }
}

.qualifierImage {
    max-width: 100%;
    height: auto;
}

.qualifierCaption {
    text-wrap: pretty;
}

.orDivider {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--spacer-8);
    padding-inline: var(--spacer-24);
    font: var(--font-h-24);

    &::before,
    &::after {
        content: "";
        flex: 1;
        width: 1px;
        background-color: var(--pecan);
    }

    @media ($below-tablet) {
        /* Hide the inter-column dividers — the cross is drawn by the
         * grid's 1px gap showing through; only the middle one is kept,
         * absolutely positioned to punch the "or" word through the
         * intersection. */
        display: none;

        &:nth-of-type(2) {
            display: flex;
            flex-direction: row;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            padding: 0 var(--spacer-12);
            background-color: var(--color-primary);

            &::before,
            &::after {
                display: none;
            }
        }
    }
}

.additionalImageWrapper {
    text-align: center;
}

.additionalImage {
    display: inline-block;
    width: 400px;
    max-width: 100%;
    height: auto;
}
